import React from 'react';
import Lozenge from '@atlaskit/lozenge';

import { SloTypeFields, SloTypeCompactFields } from '@/components/composed/forms/data-mapper';

interface SloTypeLozengeProps {
  type?: API.SLOTypeName;
  isCompact?: boolean;
  isMimir?: boolean;
}

const SloTypeLozenge: React.FC<SloTypeLozengeProps> = ({
  type = SloTypeFields.RELIABILITY.value,
  isCompact,
  isMimir,
}) => {
  if (isMimir) {
    return <Lozenge>{type}</Lozenge>;
  }

  return (
    <Lozenge maxWidth="250px">
      {isCompact ? SloTypeCompactFields[type].label : SloTypeFields[type].label}
    </Lozenge>
  );
};

export default SloTypeLozenge;
